import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { OtherDataViewModel } from 'src/app/receipt-long-op/view-models/other-data.view-model';
import { firstValueFrom, Observable } from 'rxjs';
import { ExpandableComponent, LabelledTextBoxComponent, MessageResourceManager, NTSTranslatePipe } from '@nts/std';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NgIf } from '@angular/common';
import { BaseStepComponent } from '../base-step.component';
import { WeaSettingsDataDto } from 'src/app/create-expense-annotation-long-op/api-clients/dto/wea-settings-data.dto';
import { ManageOtherData } from 'src/app/wea-settings/domain-models/manage-other-data';

@UntilDestroy()
@Component({
  selector: 'nts-other-data-step',
  templateUrl: './other-data-step.component.html',
  styleUrls: ['./other-data-step.component.scss'],
  standalone: true,
  imports: [
    NTSTranslatePipe,
    SvgIconComponent,
    ExpandableComponent,
    LabelledTextBoxComponent,
    NgIf
  ]
})
export class OtherDataStepComponent extends BaseStepComponent<OtherDataViewModel> {

  untilDestroyed(): <U>(source: Observable<U>) => Observable<U> {
    return untilDestroyed(this);
  }

  get currentConfiguration(): WeaSettingsDataDto {
    return this.rootViewModel.params.expenseData.configuration;
  }

  get otherDataConfiguration(): ManageOtherData {
    return this?.currentConfiguration?.manageOtherData;
  }

  async onViewModelLoaded() {

    this.receiptStepsService.stepLoading.next(true);

    const viewModel = this.receiptStepsService.getCurrentState() as OtherDataViewModel;

    const rootViewModel = this.receiptStepsService.orchestratorViewModel.rootViewModel;

    const queryParams = await firstValueFrom(this.routeStateService.queryParams);
    let expenseAnnotationId = null;
    if (queryParams['expenseAnnotationId']) {
      expenseAnnotationId = parseInt(queryParams['expenseAnnotationId'], 10);
    }
    const remoteExpense = queryParams['remoteExpense'] === 'true';

    viewModel.initPresentationLogic(
      expenseAnnotationId,
      remoteExpense,
      rootViewModel.params.expenseSelection.expenseClassification.value,
      rootViewModel.params.expenseState,
      !(await this.isReadOnly(rootViewModel))
    );

    this.receiptStepsService.orchestratorViewModel.rootViewModelModified.pipe(untilDestroyed(this)).subscribe(() => {
      viewModel.validateStep();
    });

    viewModel.validateStep();

    this.inIframe = this.activatedRoute.snapshot.queryParams['iframe'] === 'true' || window.self !== window.top;


    this.receiptStepsService.stepLoading.next(false);

    this.viewModel = viewModel;

    const customTitle = viewModel.newLabels().value[viewModel.currentExpenseClassificationType];
    const title = customTitle ?? MessageResourceManager.Current.getMessage('ExpenseClassification_' + viewModel.expenseClassificationEnum[viewModel.currentExpenseClassificationType]);
    this.telemetryService.trackPageView({ name: title });
  };

}

